import { WDD } from '../core/wdd.js';
import { swapImage, generateSrcset } from '../utils/swapImage.js';

export function variants() {
    const colorButtons = WDD.el.querySelectorAll('.bp-detail__color');
    const headline = WDD.el.querySelector('.bp-detail__headline');
    const buyButton = WDD.el.querySelector('.bp-button--buy');
    const detailImg = WDD.el.querySelector('.bp-detail__img picture img');
    const galleryThumbs = WDD.el.querySelectorAll('.bp-gallery__thumb');

    colorButtons.forEach(button => {
        button.addEventListener('click', async () => {
            // 1. Check if already active
            if (button.classList.contains('bp-detail__color--active')) {
                return;
            }

            // 2. Update active color class
            colorButtons.forEach(btn => btn.classList.remove('bp-detail__color--active'));
            button.classList.add('bp-detail__color--active');

            // Get new color and data
            const newColor = button.getAttribute('data-img');
            const newUrl = button.getAttribute('data-url');
            const newOid = button.getAttribute('data-oid');
            const newName = button.getAttribute('data-name');

            // 3. Update variant class on WDD.el
            WDD.el.className = WDD.el.className.replace(/bp--\w+/g, '');
            WDD.el.classList.add(`bp--${newColor}`);

            // 4. Update buy button
            if (buyButton) {
                buyButton.setAttribute('data-oid', newOid);
                buyButton.setAttribute('href', newUrl);
            }

            // 5. Update headline text
            if (headline) {
                headline.textContent = newName;
            }

            // 6. Update images - main image
            if (detailImg) {
                // Get current active thumbnail number
                const activeThumb = Array.from(galleryThumbs).find(thumb =>
                    thumb.classList.contains('bp-gallery__thumb--active')
                );
                const thumbNumber = activeThumb?.getAttribute('data-img') || '01';

                // Build new image URL
                const currentPath = detailImg.src.substring(0, detailImg.src.lastIndexOf('/') + 1);
                const newImageUrl = `${currentPath}${newColor}-${thumbNumber}.png`;

                // Swap main image with animation
                swapImage(detailImg, newImageUrl);
            }

            // Update all thumbnails with animation
            Array.from(galleryThumbs).forEach(thumb => {
                const thumbImg = thumb.querySelector('img');
                if (!thumbImg) return;

                const thumbNumber = thumb.getAttribute('data-img');
                const currentPath = thumbImg.src.substring(0, thumbImg.src.lastIndexOf('/') + 1);
                const newThumbUrl = `${currentPath}${newColor}-${thumbNumber}.png`;

                swapImage(thumbImg, newThumbUrl);
            });
        });
    });
}
